export const withoutSpaces = (text: string): string => text.replace(/\s/g, '');
